import React, {useState, useRef, useEffect} from 'react'
import {Button, Form, Modal} from "react-bootstrap";
import ReactQuill from "react-quill";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileExcel, faFilePdf, faImage, faFile} from "@fortawesome/free-solid-svg-icons";
// @ts-ignore
import {constants} from "../../../config/constants";
import axios from "axios";
import {zynity_api} from "../../../config/external-routes";
import {useSelector} from "react-redux";
import Swal from "sweetalert2";
import './headlineModal/HeadlineModal.scss'
import ModalDialog from 'react-bootstrap/ModalDialog';
import Draggable from 'react-draggable';
import TeamEventAccordion from '../../calendar/TeamEventAccordion';
import { DocumentLibraryPickerItem, DocumentLibraryPickerModal } from './DocumentLibraryPickerModal';


class DraggableModalDialog extends React.Component {
    render() {
        return <Draggable handle=".draggableHandler"><ModalDialog {...this.props} />
        </Draggable>
    }
}

export const HeadlineModal = ({showCreateModal, handleCloseModal, data, setData, submitHandled, settings, eventData, setEventData, showEmailMembers = false, emailMemberList = [], selectedEmailMembers, setSelectedEmailMembers, disableSubmitBtn, showDoNotNotify = false}:any) => {
    const authenticated_user = useSelector(state => state.auth)
    const inputFileRef = useRef( null );
    let links = Array.isArray(data.links) ? data.links : [];
    const uploads = Array.isArray(data.uploads) ? data.uploads : [];
    const documentLibraryItemIds = data.document_library_item_ids || [];
    const documentLibraryItems = data.document_library_items || [];
    const visibleLinks = links.filter((link:any) => !link?.document_library_item_id);
    const visibleUploads = uploads.filter((upload:any) => !upload?.document_library_item_id);
    const [uploading, setUploading] = useState(0);
    const [modalClass, setModalClass] = useState('custom-modal-width');
    const [modalMaximizeBtnText, setModalMaximizeBtnText] = useState('Maximize Window');
    const [doNotNotify, setDoNotNotify] = useState(false);
    const [showDocumentLibraryPicker, setShowDocumentLibraryPicker] = useState(false);

    const addLinkInputHandle = () => {
        setData({
            ...data,
            'links': [...links, {id: null, link: ''}]
        })
    }

    const removeUploadHandle = (file_name:any) => {
        const uploadToRemove = data.uploads.find((upload:any) => upload.file_name === file_name);
        let arr = data.uploads.filter((upload:any) => {
            return upload.file_name !== file_name;
        });

        setData({
            ...data,
            'uploads': arr,
            'document_library_item_ids': uploadToRemove?.document_library_item_id
                ? documentLibraryItemIds.filter((id:number) => id !== uploadToRemove.document_library_item_id)
                : documentLibraryItemIds,
            'document_library_items': uploadToRemove?.document_library_item_id
                ? documentLibraryItems.filter((item: DocumentLibraryPickerItem) => item.id !== uploadToRemove.document_library_item_id)
                : documentLibraryItems,
        })
    }

    const removeLink = (key:any) => {
        const removedLink = links[key];
        let newLinks = links.filter((link:any, index:any) => index !== key);

        setData({
            ...data,
            'links': newLinks,
            'document_library_item_ids': removedLink?.document_library_item_id
                ? documentLibraryItemIds.filter((id:number) => id !== removedLink.document_library_item_id)
                : documentLibraryItemIds,
            'document_library_items': removedLink?.document_library_item_id
                ? documentLibraryItems.filter((item: DocumentLibraryPickerItem) => item.id !== removedLink.document_library_item_id)
                : documentLibraryItems,
        })
    }

    const addUploadHandle = (e:any) => {
        const formData = new FormData();
        let file = e.target.files[0];
        formData.append('file', file, file.name)
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${authenticated_user.access_token}`
            },
            onUploadProgress: function(progressEvent:any) {
                setUploading(Math.round( (progressEvent.loaded * 100) / progressEvent.total ));
            }
        }
        axios.post(zynity_api.global_upload_temp_files, formData, config).then(response => {
            setUploading(0);
            setData({
                ...data,
                'uploads': [...data.uploads, {
                    "id": null,
                    "file_name": response.data.file_name,
                    "display_name": response.data.display_name,
                }]
            })

        }).catch((e) => {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'We have problems uploading your file!',
            })
        })
    }

    const addLinkInputDataHandle = (key:any, newVal:any) => {
        let newLinks = links.map((link:any, index:any) => {
            if(index === key) {
                return {...link, link: newVal};
            } else {
                return link;
            }
        })
        setData({
            ...data,
            'links': newLinks
        })
    }

    const handleSelectDocumentLibraryItem = (item: DocumentLibraryPickerItem) => {
        if (documentLibraryItemIds.includes(item.id)) {
            setShowDocumentLibraryPicker(false);
            return;
        }

        let nextLinks = [...links];
        let nextUploads = [...uploads];

        if (item.type === 'internal_doc') {
            nextUploads = [
                ...uploads,
                {
                    id: null,
                    file_name: item.storage_path,
                    display_name: item.display_name || item.title,
                    document_library_item_id: item.id,
                },
            ];
        } else {
            nextLinks = [
                ...links,
                {
                    id: null,
                    link: item.external_url || '',
                    document_library_item_id: item.id,
                },
            ];
        }

        setData({
            ...data,
            links: nextLinks,
            uploads: nextUploads,
            document_library_item_ids: [...documentLibraryItemIds, item.id],
            document_library_items: [...documentLibraryItems, item],
        });
        setShowDocumentLibraryPicker(false);
    };

    const removeDocumentLibraryItem = (itemId:number) => {
        const item = documentLibraryItems.find((entry: DocumentLibraryPickerItem) => entry.id === itemId);
        setData({
            ...data,
            document_library_item_ids: documentLibraryItemIds.filter((id:number) => id !== itemId),
            document_library_items: documentLibraryItems.filter((entry: DocumentLibraryPickerItem) => entry.id !== itemId),
            links: item?.external_url
                ? links.filter((entry:any) => !(entry.document_library_item_id === itemId || entry.link === item.external_url))
                : links.filter((entry:any) => entry.document_library_item_id !== itemId),
            uploads: item?.storage_path
                ? uploads.filter((entry:any) => !(entry.document_library_item_id === itemId || entry.file_name === item.storage_path))
                : uploads.filter((entry:any) => entry.document_library_item_id !== itemId),
        });
    };

    let labels = {
        title: settings.labels?.title === undefined ? 'Title' : settings.labels.title,
        description: settings.labels?.description === undefined ? 'Description' : settings.labels.description,
        links: settings.labels?.links === undefined ? 'Links' : settings.labels.links,
        uploads: settings.labels?.uploads === undefined ? 'Uploads' : settings.labels.uploads,
    }

    const handleCheckboxChange = (event:any) => {
        const checkboxId = parseInt(event.target.value);
        if (selectedEmailMembers.includes(checkboxId)) {
            setSelectedEmailMembers(selectedEmailMembers.filter((id: number) => id !== checkboxId));
        } else {
            setSelectedEmailMembers([...selectedEmailMembers, checkboxId]);
        }
    }

    const handleSelectAllChange = (event:any) => {
        if (event.target.checked) {
            const allIds = emailMemberList.map((data:any) => data.id);
            setSelectedEmailMembers(allIds);
        } else {
            setSelectedEmailMembers([]);
        }
    }

    const handleMaximize = () => {
        if(modalClass == 'custom-modal-width-xl') {
            setModalClass('custom-modal-width');
            setModalMaximizeBtnText('Maximize Window');
        } else {
            setModalClass('custom-modal-width-xl');
            setModalMaximizeBtnText('Minimize Window');
        }
    }

const [showEventForm, setShowEventForm] = useState(false);

useEffect(() => {
    if(eventData?.start_date != '' && showEventForm == false) {
        setShowEventForm(true)
    }
}, [eventData])

useEffect(() => {
    if(showCreateModal !== true) {
        setShowDocumentLibraryPicker(false);
    }
}, [showCreateModal])

    const showDraftUi = settings?.is_comment !== true && (settings?.new_record === true || settings?.is_draft === true);

    return (
        <>
            <Modal show={showCreateModal && showDocumentLibraryPicker === false} onHide={handleCloseModal} dialogClassName={modalClass}
                   dialogAs={DraggableModalDialog}
            >
                <Form>
                    <Modal.Header closeButton className='bg-teal draggableHandler modalWithoutCloseMargin' style={{cursor: 'grab'}}>
                        <Modal.Title className='d-flex align-items-center'>
                            <span>{settings.title}</span>
                            {
                                showDraftUi &&
                                <span
                                    className='badge mx-2'
                                    style={{backgroundColor: 'white', color: 'teal', border: '1px solid #c9e7e7'}}
                                >
                                    DRAFT
                                </span>
                            }
                        </Modal.Title>
                        <div className="ms-auto d-flex align-items-center">
                            <button type="button" className="btn btn-teal me-2" onClick={handleMaximize}>{modalMaximizeBtnText}</button>
                        </div>
                    </Modal.Header>
                    <Modal.Body className='row d-flex align-items-center'>
                    {
                        settings.is_comment !== true &&
                        <>
                            {/* Title */}
                            <div className="row mt-3">
                                <div className="col-12 col-md-2 text-md-end">
                                    <Form.Label>{labels.title} *</Form.Label>
                                </div>

                                <div className="col-12 col-md-10">
                                    <Form.Control type="text" placeholder={labels.title}
                                        value={data.title}
                                        onChange={(e) => {setData({ ...data, title: e.target.value})}}
                                    />
                                </div>
                            </div>
                        </>
                    }

                    {/* Description (Story) */}
                    <div className="row mt-3">
                        <div className="col-12 col-md-2 text-md-end">
                            <Form.Label>{labels.description}</Form.Label>
                        </div>
                        <div className="col-12 col-md-10">
                            <ReactQuill
                                theme="snow"
                                placeholder='Description'
                                value={data.description}
                                onChange={(val) => {setData({ ...data, description: val})}}
                                modules={constants.quillDefaultModules}
                                formats={constants.quillDefaultFormats}
                            />
                        </div>
                    </div>

                    {
                        ['Deliverable', 'TOMI', 'Activity'].some(type => settings?.title?.includes(type)) && (
                            <>
                    <div className="row mt-3">
                        <div className="col-12 col-md-2 text-md-end">
                            <Form.Label>Calendar</Form.Label>
                        </div>
                        <div className="col-12 col-md-10">
                            <TeamEventAccordion
                                show={showEventForm}
                                setShow={setShowEventForm}
                                eventData={eventData}
                                onEventDataChange={setEventData}
                                teamId={data.team_id}
                                teamMembers={emailMemberList}
                            />
                        </div>
                    </div>
                            </>
                        )
                    }

                    {/* Links (URLs) */}
                    {
                        settings?.enable_document_library === true &&
                        <div className="row mt-3">
                            <div className="col-12 col-md-2 text-md-end">
                                <Form.Label>Library</Form.Label>
                            </div>
                            <div className="col-12 col-md-10">
                                {
                                    documentLibraryItems.length > 0 &&
                                    <div className="mb-2 d-flex flex-column gap-2">
                                        {documentLibraryItems.map((item: DocumentLibraryPickerItem) => (
                                            <div key={item.id} className="card">
                                                <div className="card-body d-flex justify-content-between align-items-center p-2">
                                                    <div>
                                                        <div className="fw-bold">{item.title}</div>
                                                        <div className="small text-muted">
                                                            {item.type === 'internal_doc' ? 'Internal document' : item.type === 'external_doc' ? 'External document' : 'Link'}
                                                        </div>
                                                    </div>
                                                    <button type="button" className="btn-close" onClick={() => removeDocumentLibraryItem(item.id)}></button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                }
                                <Button type="button" className='btn-teal mt-0' size="sm" onClick={() => setShowDocumentLibraryPicker(true)}>
                                    Choose from Library
                                </Button>
                            </div>
                        </div>
                    }

                    <div className="row mt-3">
                        <div className="col-12 col-md-2 text-md-end">
                            <Form.Label>{labels.links}</Form.Label>
                        </div>
                        <div className="col-12 col-md-10">
                            {
                                visibleLinks.map((link:any) => (
                                    <>
                                        <div className='d-flex justify-content-between'>
                                            <Form.Control className='mt-0 d-inline' type="url" placeholder="Add a url here..."
                                                value={link.link}
                                                onChange={(e) => {
                                                    const rawKey = links.findIndex((entry:any) => entry === link);
                                                    addLinkInputDataHandle(rawKey, e.target.value)
                                                }}
                                            />
                                            <button
                                                type="button"
                                                style={{marginLeft: '10px'}}
                                                className="btn-close mt-4"
                                                onClick={() => {
                                                    const rawKey = links.findIndex((entry:any) => entry === link);
                                                    removeLink(rawKey)
                                                }}
                                            ></button>
                                        </div>
                                    </>
                                ))
                            }
                            <Button type="button" className='btn-teal mt-0' size="sm" onClick={addLinkInputHandle}>Add Link</Button>{' '}
                        </div>
                    </div>

                    {/* Uploads */}
                    <div className="row mt-3">
                        <div className="col-12 col-md-2 text-md-end">
                            <Form.Label>{labels.uploads}</Form.Label>
                        </div>
                        <div className="col-12 col-md-10">
                            <div className="row">
                                {
                                    visibleUploads.length > 0 &&
                                    visibleUploads.map((upload:any) => (
                                        <div className="col-12 mt-0">
                                            <div className='card'>
                                                <div className="card-body d-flex justify-content-between align-items-center p-2">
                                                    <span className='d-flex align-items-center'>
                                                        <FontAwesomeIcon icon={faFile} style={{color: "#007eda", height: '35', width: 'auto'}}/> <span className='mx-1'>{upload.display_name}</span>
                                                    </span>
                                                    <button type="button" className="btn-close" onClick={() => {removeUploadHandle(upload.file_name)}}></button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                                {
                                    uploading > 0 &&
                                    (
                                        <div className="col-12 mt-2 mb-2">
                                            <div className="progress">
                                                <div
                                                    className="progress-bar progress-bar-striped progress-bar-animated"
                                                    role="progressbar"
                                                    aria-valuenow="0"
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                    style={{width: `${uploading}%`}}
                                                >
                                                    Uploading {uploading}%
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                <input type="file"
                                    style={{display: 'none'}}
                                    ref={inputFileRef}
                                    onChange={addUploadHandle}
                                />
                                <div className="col-12"><Button type="button" className='btn-teal mt-1' size="sm" onClick={() => {inputFileRef.current.click()}}>
                                {visibleUploads.length > 0 ? 'Add More Files' : 'Add File'}</Button>{' '}</div>
                            </div>
                        </div>
                    </div>

                    {
                        showEmailMembers &&
                        <>
                            {/* Send Email Selection */}
                            <div className="row mt-3">
                                <div className="col-12 col-md-2 text-md-end">
                                    <Form.Label>Email Members</Form.Label>
                                </div>
                                <div className="col-12 col-md-10">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={selectedEmailMembers.length === emailMemberList.length}
                                            onChange={handleSelectAllChange}
                                        />
                                        All
                                    </label>
                                    {emailMemberList.map((data:any) => (
                                        <label key={data.id} className='mx-1'>
                                            <input
                                                className='mx-1'
                                                type="checkbox"
                                                value={data.id}
                                                checked={selectedEmailMembers.includes(data.id)}
                                                onChange={handleCheckboxChange}
                                            />
                                            {data.KnownAs}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </>
                    }


                    </Modal.Body>
                    <Modal.Footer>
                        {
                            showDraftUi &&
                            <Button
                                className='btn btn-save-draft-outline'
                                onClick={() => submitHandled(doNotNotify, true)}
                                disabled={disableSubmitBtn}
                            >
                                Save as draft
                            </Button>
                        }
                        {showDoNotNotify && (
                            <Form.Check
                                type="checkbox"
                                id="doNotNotifyCheckbox"
                                label="Do not notify"
                                checked={doNotNotify}
                                onChange={(e) => setDoNotNotify(e.target.checked)}
                                className="me-3"
                            />
                        )}
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Cancel
                        </Button>
                        <Button className='btn-teal' onClick={() => submitHandled(doNotNotify, false)} disabled={disableSubmitBtn}>
                            Post
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <DocumentLibraryPickerModal
                show={showDocumentLibraryPicker}
                onHide={() => setShowDocumentLibraryPicker(false)}
                onSelectItem={handleSelectDocumentLibraryItem}
                selectedItemIds={documentLibraryItemIds}
            />
        </>
    )
}
